<template>
    <ListeMotifSuivi/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
import ListeMotifSuivi from "@/components/GesCom/MotifSuivi/ListeMotifSuivi.vue";

    export default defineComponent({
      name: "ListeMotifSuiviPage",
      components: {
        
        ListeMotifSuivi,
      },
    });
  </script>